import { render, staticRenderFns } from "./Kataloganforderung.vue?vue&type=template&id=5ae0e2ac"
import script from "./Kataloganforderung.vue?vue&type=script&lang=js"
export * from "./Kataloganforderung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports